import { Link } from "../../lib/router-compat.jsx";
import PublicShell from "../../components/shell/PublicShell.jsx";
import { EmptyState, Icon } from "../../ui/index.js";

export default function NotFoundPage() {
  return (
    <PublicShell>
      <div className="container" style={{ padding: "96px 0" }}>
        <EmptyState
          icon={<Icon.Search size={40} />}
          title="Page not found"
          body="The page you're looking for doesn't exist or has moved."
          action={<Link to="/" className="btn btn--primary">Back to home</Link>}
        />
      </div>
    </PublicShell>
  );
}
